import React, { useMemo } from 'react';
import Styles from './FormPersonalData.css';
import clsx from 'clsx';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { Controller } from 'react-hook-form';
import Select from '../../widgets/Select/Select';
import { combineFieldProps } from '../../shared/utils/form';
import TextField from '../../widgets/TextField/TextField';
import Button from '../../widgets/Button/Button';
import { useScroll } from '../../../../utils/useLayout';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import { useFormPersonalData } from '../../model/form-personal-data';
import Checkbox from '../../widgets/Checkbox/Checkbox';

function FormPersonalData() {
  const { scrollToTop } = useScroll();

  const state = useSimuladorEnergiaSolarState();
  const formPersonalData = useFormPersonalData();

  const hidden = state.simulationStep?.id !== SIMULATION_STEPS.FORM_PERSONAL_DATA.id;

  const title = useMemo(() => {
    if (formPersonalData.isCPF) return 'Dados pessoais';

    if (formPersonalData.currentStep > 2) return 'Dados do Representante legal (Sócio)';

    return 'Dados da empresa';
  }, [formPersonalData.currentStep, formPersonalData.isCPF]);

  return (
    <>
      <div
        id="form-personal-data"
        className={clsx({
          personal: true,
          hidden,
        })}
      >
        <ContainerHome24>
          <h2 className="personal-title">
            <img
              src={
                formPersonalData.isCPF
                  ? 'assets/simulador-energia-solar/jornada/ic-house.svg'
                  : 'assets/simulador-energia-solar/jornada/ic-company.svg'
              }
              alt=""
            />
            {title}
            <small>&nbsp;{`(${formPersonalData.currentStep}/${formPersonalData.maxSteps})`}</small>
          </h2>

          {formPersonalData.currentStep === 1 && (
            <p className="personal-subtitle">
              Em poucas etapas você envia sua proposta para o financiamento. <b>Sem compromisso!</b>
              <br />
              <br />
              Informe os dados abaixo.
            </p>
          )}

          {formPersonalData.currentStep === 2 && (
            <p className="personal-subtitle">
              {formPersonalData.isCPF
                ? 'Para finalizar, seus dados de endereço'
                : 'Só mais algumas informações para conseguirmos validar os dados da empresa corretamente'}
            </p>
          )}

          {formPersonalData.currentStep === 3 && (
            <p className="personal-subtitle">
              {formPersonalData.isCPF
                ? 'Para finalizar, seus dados de endereço'
                : 'Só mais algumas informações para conseguirmos validar os dados da empresa corretamente'}
            </p>
          )}

          {formPersonalData.currentStep === 4 && (
            <p className="personal-subtitle">
              E para finalizar, os dados de endereço do Representante legal para conseguirmos
              validar os dados da empresa corretamente
            </p>
          )}

          <form className="form-render" onSubmit={formPersonalData.handleSubmit}>
            {formPersonalData.fields.map((field) => {
              return (
                <Controller
                  key={`field-${field.name}`}
                  name={field.name}
                  control={formPersonalData.form.control}
                  render={(renderOptions) => {
                    const isSelect = field.type === 'select';
                    const fieldProps = combineFieldProps(field, renderOptions);
                    const isPostalCode =
                      field.name === 'postalCode' || field.name === 'legalRepPostalCode';

                    return (
                      <div className={clsx({ 'field-wrapper': true })}>
                        {isSelect && (
                          <Select
                            {...fieldProps}
                            handleValueChange={(v) => {
                              formPersonalData.form.setValue(field.name, v, {
                                shouldDirty: true,
                                shouldTouch: true,
                                shouldValidate: true,
                              });
                            }}
                          />
                        )}

                        {!isSelect && <TextField {...fieldProps} />}

                        {field.name === 'addressNumber' && (
                          <Checkbox
                            id="chk-sem-numero"
                            checked={formPersonalData.isNoAddressNumberChecked}
                            label="Sem número"
                            handleChange={(checked) => {
                              formPersonalData.form.setValue('noAddressNumber', checked, true);

                              if (checked && renderOptions.field.value !== '') {
                                formPersonalData.form.setValue(field.name, '', true);
                              }

                              if (checked) {
                                formPersonalData.form.clearErrors(field.name);
                              }
                            }}
                          />
                        )}

                        {field.name === 'legalRepAddressNumber' && (
                          <Checkbox
                            id="chk-sem-numero"
                            checked={formPersonalData.isNoAddressNumberChecked2}
                            label="Sem número"
                            handleChange={(checked) => {
                              formPersonalData.form.setValue('noAddressNumber2', checked, true);

                              if (checked && renderOptions.field.value !== '') {
                                formPersonalData.form.setValue(field.name, '', true);
                              }

                              if (checked) {
                                formPersonalData.form.clearErrors(field.name);
                              }
                            }}
                          />
                        )}

                        {isPostalCode && (
                          <a
                            id="cta-nao-sei-cep"
                            href={state.linkFindCEP || 'https://buscacepinter.correios.com.br'}
                            rel="noreferrer"
                            target="_blank"
                          >
                            Não sei meu CEP
                          </a>
                        )}
                      </div>
                    );
                  }}
                />
              );
            })}
          </form>

          <div className="button-row-form">
            <Button
              disabled={formPersonalData.loading}
              variant="white"
              onClick={() => {
                if (formPersonalData.currentStep === 1) {
                  state.setSimulationStep(SIMULATION_STEPS.END_CONFIRMATION);
                  scrollToTop();
                  return;
                }

                formPersonalData.gotoPreviousStep();
                scrollToTop();
              }}
            >
              Voltar
            </Button>
            <Button
              disabled={formPersonalData.loading}
              loading={formPersonalData.loading}
              variant="red"
              type="submit"
              onClick={(ev) => {
                formPersonalData.handleSubmit(ev).then(scrollToTop);
              }}
            >
              {formPersonalData.shouldValidatePostalCode ? 'Buscar CEP' : 'Continuar'}
            </Button>
          </div>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default FormPersonalData;
